// ** React Imports

// ** Custom Components

// ** Third Party Components
import { Bell } from 'react-feather'
import PerfectScrollbar from 'react-perfect-scrollbar'

// ** Reactstrap Imports
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap'
import useJunctionId from '../../../../hooks/useJunctionId'
import { useRecentAlarms } from '../../../../hooks/useQuery/useRecentAlarms'
import AlarmTable from '../../../../views/alarms/components/AlarmTable'

const NotificationDropdown = () => {
  const { junctionId } = useJunctionId()

  const { isLoading: recentAlarmLoading, data: recentAlarm } =
    useRecentAlarms(junctionId)

  /*eslint-disable */
  const renderNotificationItems = () => {
    return (
      <PerfectScrollbar
        component='li'
        className='media-list scrollable-container'
        options={{
          wheelPropagation: false,
        }}
      >
        {recentAlarm ? (
          <AlarmTable
            alarmData={recentAlarm.junction_alarms.slice(0, 5)}
            header={true}
          />
        ) : null}
      </PerfectScrollbar>
    )
  }

  return (
    <UncontrolledDropdown
      tag='li'
      className='dropdown-notification nav-item me-25'
    >
      <DropdownToggle
        tag='a'
        className='nav-link'
        href='/'
        onClick={(e) => e.preventDefault()}
      >
        <Bell size={21} />
      </DropdownToggle>
      <DropdownMenu end tag='ul' className='dropdown-menu-media mt-0'>
        <li className='dropdown-menu-header'>
          <DropdownItem className='d-flex' tag='div' header>
            <h4 className='notification-title mb-0 me-auto'>Recent Alarms</h4>
          </DropdownItem>
        </li>
        {renderNotificationItems()}
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default NotificationDropdown
